__turbopack_context__.v({
  "additionalServices": "Summary-module__4ft3Ca__additionalServices",
  "appFeeContent": "Summary-module__4ft3Ca__appFeeContent",
  "container": "Summary-module__4ft3Ca__container",
  "divider": "Summary-module__4ft3Ca__divider",
  "infoIcon": "Summary-module__4ft3Ca__infoIcon",
  "instalments": "Summary-module__4ft3Ca__instalments",
  "instalmentsContainer": "Summary-module__4ft3Ca__instalmentsContainer",
  "instalmentsList": "Summary-module__4ft3Ca__instalmentsList",
  "monthlyRate": "Summary-module__4ft3Ca__monthlyRate",
  "summary": "Summary-module__4ft3Ca__summary",
  "totalAmountLabel": "Summary-module__4ft3Ca__totalAmountLabel",
  "totalMonthlyRate": "Summary-module__4ft3Ca__totalMonthlyRate",
});
